<template>
  <div class="gradient-background" :style="style"></div>
</template>
<script>
import { filter } from 'lodash';

export default {
  name: 'WGradientBackground',
  components: {
  },
  props: {
    options: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    style() {
      const colors = filter(this.options.gradientColors, (color) => color !== null).join(',');
      return {
        background: `linear-gradient(-65deg, ${colors})`,
      };
    },
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.gradient-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 400% 400% !important;
  -webkit-animation: Gradient 15s ease infinite;
  -moz-animation: Gradient 15s ease infinite;
  animation: Gradient 15s ease infinite;
}

@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/GradientBackground.vue